/**
 *
 * StreamlineIcons
 *
 */

import React from 'react';
import classnames from 'classnames';
import styled from 'styled-components';

import styles from './StreamlineIcon.style';

export interface StreamlineIconProps extends React.SVGAttributes<SVGElement> {
  size?: number;
  position?: 'left' | 'right';
  className?: string;
  // @ts-ignore
  icon: React.ComponentType;
  wrapperProps?: React.HTMLAttributes<HTMLSpanElement>;
  filled?: boolean;
  iconColor?: string;
  strokeWidth?: number;
}

const StreamlineIcon: React.FC<StreamlineIconProps> = ({
  size,
  position,
  className,
  wrapperProps,
  icon,
  filled,
  iconColor,
  ...extraProps
}) => {
  const Component = icon;
  return (
    <span {...wrapperProps} className={classnames('fil-icon-wrapper', className)}>
      {/* @ts-ignore */}
      <Component className="fil-svg-icon" {...extraProps} />
    </span>
  );
};

const StyledStreamlineIcon: React.FC<StreamlineIconProps> = styled(StreamlineIcon)`
  ${styles}
`;

StyledStreamlineIcon.displayName = 'StreamlineIcon';

export default StyledStreamlineIcon;
